module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS4.fb0867b6.jpg";